import React from "react";
import { Dialog, DialogContent, DialogTitle, GridLegacy } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import FormSwitchTC from "../../components/Forms/FormSwitchTC";
import FormAsyncTC from "../../components/Forms/FormAsyncTC";
import AuthProvider from "../../auth/AuthProvider";

const endPoint = "core/profiles/duplicate";

function CreateNewProfileDialog(props) {
  return (
    <Dialog fullWidth={true} maxWidth={"lg"} onClose={() => props.onClose()} open={true}>
      <DialogTitle>
        <TranslationWrapper tDefault={"Create new profile"} tKey={"profiles.createNewProfile"} />
      </DialogTitle>
      <DialogContent>
        <AuthProvider prefix={"create_new_profile"}>
          <FormV2
            endPoint={endPoint}
            getEditLink={(row) => {
              return `./${row.id}/edit`;
            }}
          >
            <GridLegacy container spacing={1}>
              <FormTextTC
                name={"name"}
                rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
                tDefault={"Profile name"}
                tKey={"profiles.name"}
              />
              <FormAsyncTC
                async={{
                  url: "core/profiles/search?fields=id as value, name as label,profile_type_id,profile_type.rank,profile_type.id&per_page=50",
                  searchField: "name",
                  sort: (a, b) => a.profile_type.rank - b.profile_type.rank,
                }}
                name={"duplicate_from_id"}
                permissionKey={"other_profile"}
                rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
                tDefault={"Select a profile to copy rights from"}
                tKey={"profiles.selectOtherProfile"}
              />
              <FormSwitchTC
                name={"global"}
                tDefault={"Create a global profile"}
                tKey={"profiles.createGlobalProfile"}
              />
            </GridLegacy>
          </FormV2>
        </AuthProvider>
      </DialogContent>
    </Dialog>
  );
}

export default CreateNewProfileDialog;
